var _rect, _rect2, _path, _ellipse, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDocumentCheck = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.26343,
    y: 3.79004,
    width: 17.6871,
    height: 13.2653,
    fill: "#EDF4FE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.89502,
    y: 1.26367,
    width: 6.31682,
    height: 13.2653,
    fill: "#EDF4FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.36897 0C2.43866 0 1.68449 0.75417 1.68449 1.68449V2.52673C1.68449 2.57445 1.68647 2.62172 1.69036 2.66844C0.705919 3.01364 0 3.95111 0 5.05346V15.1604C0 16.5559 1.13126 17.6871 2.52673 17.6871H17.6871C19.0826 17.6871 20.2138 16.5559 20.2138 15.1604V5.05346C20.2138 3.65798 19.0826 2.52673 17.6871 2.52673H10.0008C9.62679 1.07367 8.30775 0 6.73794 0H3.36897ZM8.19708 2.52673C7.90582 2.02324 7.36144 1.68449 6.73794 1.68449H3.36897V2.52673H8.19708ZM2.52673 4.21122C2.06157 4.21122 1.68449 4.5883 1.68449 5.05346V15.1604C1.68449 15.6255 2.06157 16.0026 2.52673 16.0026H17.6871C18.1523 16.0026 18.5293 15.6255 18.5293 15.1604V5.05346C18.5293 4.5883 18.1523 4.21122 17.6871 4.21122H2.52673Z",
    fill: "#B9D5F7"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.9485,
    cy: 15.4221,
    rx: 4.05148,
    ry: 4.05148,
    fill: "#45B23B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6593 16.5916L16.4622 15.4952L16.8612 15.1298L17.6593 15.8607L19.2556 14.3988L19.6546 14.7643L17.6593 16.5916Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDocumentCheck);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/documentCheck.a468ceb1fae710c51990cbb76dd4d269.svg";